import { Form, useFormContext } from "@/components/form";
import { getAllProveedores } from "@/features/auxiliar/proveedores/api/get-all-proveedores";
import { getProveedor } from "@/features/auxiliar/proveedores/api/get-proveedor";
import { Stack } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';
import { Dialog, Drawer, ModalContextExtractor, ModalHeader, useOpenModal } from "@/components/modal";
import { AddProveedorMutation } from "@/features/auxiliar/proveedores/api/add-proveedor";
import { notify } from "@/shared/notification";
import CompraProveedorManualSearch from "./compra-proveedor-manual-search";
import { SchemaFormHook } from "@/components/form";
import AddProveedorForm, { addProveedorFormSchema } from "@/features/auxiliar/proveedores/components/add-proveedor-form";
import { getDeposito } from "@/features/inventario/depositos/api/get-deposito";
import { getAllDepositos } from "@/features/inventario/depositos/api/get-all-depositos";
import DepositoManualSearch from "@/features/inventario/depositos/components/deposito-manual-search";
import { useDepositoContext } from "@/features/inventario/deposito-actual/contexts/deposito-context";
import useHasPermisos from "@/features/auth/hooks/useHasPermisos";
import { Permiso } from "@/shared/types/permiso";
import { useEffect } from "react";

export default function CompraGeneralInfoFields() {
    const openModal = useOpenModal();

    const form = useFormContext();
    const { depositoData } = useDepositoContext();
    const hasAsignarDepositos = useHasPermisos(Permiso.AsignarDepositos);

    // Inicializar el depósito de la compra con el depósito asignado (si no hay uno elegido).
    useEffect(() => {
        const current = form.getFieldValue("depositoId");
        if (!current && depositoData?.id) {
            form.setFieldValue("depositoId", depositoData.id);
        }
    }, [depositoData?.id]);

    return <Stack gap={2} direction={"row"} flexWrap={"wrap"}>
        <Stack flex={"0 1 200px"}>
            <Form.TextField name="numComprobante" label="N° de Comprobante" size="small" />
        </Stack>
        <Stack flex={"10 1 225px"} direction={"row"} gap={1}>
            <Stack flex={1}>
                <Form.ModelComboBox name="proveedorId" label="Proveedor" get={getProveedor} getAll={getAllProveedores} size="small" />
            </Stack>
            <Form.IconButton onClick={() => openModal("addProveedor")}><AddIcon /></Form.IconButton>
            <Form.IconButton onClick={() => openModal("searchProveedor")}><SearchIcon /></Form.IconButton>
        </Stack>
        <Stack flex={"3 1 225px"} direction={"row"} gap={1}>
            <Stack flex={1}>
                <Form.ModelComboBox name="depositoId" label="Depósito" get={getDeposito} getAll={getAllDepositos} size="small" disabled={!hasAsignarDepositos} />
            </Stack>
            <Form.IconButton disabled={!hasAsignarDepositos} onClick={() => openModal("searchDeposito")}><SearchIcon /></Form.IconButton>
        </Stack>
        <Stack flex={"1 1 125px"}>
            <Form.DatePicker name="fecha" label="Fecha" size="small" />
        </Stack>

        <Drawer code="addProveedor">
            <ModalHeader>Agregar Proveedor</ModalHeader>
            <AddProveedorMutation>
                {mutation => <SchemaFormHook
                    schema={addProveedorFormSchema}
                    onSubmit={async ({ value }) => {
                        const proveedor = await mutation.mutateAsync(value);
                        notify("El proveedor se ha agregado correctamente.");
                        form.setFieldValue("proveedorId", proveedor.id);
                    }}
                    submitOnce
                    closeModalOnSubmit
                >
                    {form => <AddProveedorForm form={form} margin={3} />}
                </SchemaFormHook>}
            </AddProveedorMutation>
        </Drawer>

        <Dialog code="searchProveedor" size="lg">
            <ModalHeader>Buscar Proveedor</ModalHeader>
            <ModalContextExtractor>
                {({ handleClose }) => <CompraProveedorManualSearch
                    padding={3}
                    onProveedorSelect={proveedor => {
                        form.setFieldValue("proveedorId", proveedor.id);
                        handleClose();
                    }}
                />}
            </ModalContextExtractor>
        </Dialog>

        <Dialog code="searchDeposito" size="lg">
            <ModalHeader>Buscar Depósito</ModalHeader>
            <ModalContextExtractor>
                {({ handleClose }) => <DepositoManualSearch
                    padding={3}
                    onDepositoSelect={deposito => {
                        form.setFieldValue("depositoId", deposito.id);
                        handleClose();
                    }}
                />}
            </ModalContextExtractor>
        </Dialog>
    </Stack>
}